import React, { useState, useRef } from "react";

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import swal from "sweetalert";
import * as api from "../../../actions/api";
import StockTakeFormData from "./StockTakeFormData.js";
import { useTranslation } from "react-i18next";

import { format } from 'date-fns';
const EditStockTake = (props) => {
  const FacilityId = localStorage.getItem("FacilityId");
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const menukey = "stock-take";
  const lan = localStorage.getItem("LangCode");

  const { t, i18n } = useTranslation();

  const [formData, setFormData] = useState({
    StockTakeDate: "",
    CompleteDate: "",
    PreparedBy: "",
    ApprovedBy: "",
    ManyJsonSave: "",
    FacilityId: FacilityId,
    ItemGroupId: "",
  });

  const [IsCompleted, setIsCompleted] = useState("0");
  const [ManyTableData, setManyTableData] = useState([]);
  const [StockTakeId, setStockTakeId] = useState("0");
  const [updatedDetailGridData, setUpdatedDetailGridData] = useState([]);
  const [isFirstPhysical, setIsFirstPhysical] = useState(0);
  const [bFirst, setBFirst] = useState(true);

  const saveInFlightRef = useRef(false);

  const handleDataTableChange = (e) => {};

  const [errorObject, setErrorObject] = useState({});
  const { id } = useParams();

  const handleRDateChange = (date, field) => {
    let newDate;
    if (date == null) {
      newDate = date;
    } else {
      newDate = format(new Date(date), 'yyyy-MM-dd');
    }
    setFormData({ ...formData, [field]: newDate });
    setErrorObject({ ...errorObject, [field]: null });
  };

  const { data, refetch } = useQuery(
    ["stock-take", id, formData.ItemGroupId],
    () =>
      api.getStockTakeInv(id, formData.ItemGroupId).then((res) => {
        //This is for user has VIEW/EDIT permission in this page start
        if (props.permissionType === 1) {
          //when permissionType then it is only VIEW permission otherwise normal permission
          res.data.IsCompleted = 1;
        }
        //This is for user has VIEW/EDIT permission in this page end

        setStockTakeId(id);
        setFormData(res.data);
        setIsCompleted(res.data.IsCompleted);
        setManyTableData(res.data.ManyJsonSave);
        setUpdatedDetailGridData(res.data.ManyJsonSave);
        setIsFirstPhysical(res.data.IsFirstPhysical);
        setBFirst(true);
        return res.data;
      }),
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(id),
    }
  );

  const { isLoading: isUpdateMutating, mutate: mutateUpdate } = useMutation(
    api.updateStockTakeInv,
    {
      onSuccess: (data) => {
        if (data.status == 200) {
          refetch();
          if (data.success == 1) {
            if (data.IsCompleted == 1) {
              mutatePost(StockTakeId);
            } else {
              let route = `${data.data.StockTakeId}`;
              setIsCompleted(data.IsCompleted);
              setManyTableData(data.data.ManyJsonSave);
              props.history.push(route);

              props.openNoticeModal({
                isOpen: true,
                msg: data.message,
                msgtype: data.success,
              });
            }
          } else {
            props.openNoticeModal({
              isOpen: true,
              msg: data.message,
              msgtype: data.success,
            });
          }
        } else {
          props.openNoticeModal({
            isOpen: true,
            msg: data.message,
            msgtype: data.success,
          });
        }
      },
    }
  );

  const { isLoading: isPostMutating, mutate: mutatePost } = useMutation(
    api.postStockTakeInv,
    {
    onSuccess: (data) => {
      if (data.status == 200) {
        refetch();
        setIsCompleted(1);
        if (data.success == 0) {
          props.openNoticeModal({
            isOpen: true,
            msg: data.message,
            msgtype: data.success,
          });
        } else {
          props.openNoticeModal({
            isOpen: true,
            msg: data.message,
            msgtype: data.success,
          });
        }
      }
    },
  });

  const isSubmitting = isUpdateMutating || isPostMutating;

  const runStockTakeUpdate = (payload) => {
    if (saveInFlightRef.current || isPostMutating) return;
    saveInFlightRef.current = true;
    mutateUpdate(payload, {
      onSettled: () => {
        saveInFlightRef.current = false;
      },
    });
  };

  const handleAdd = (NonOrderProductData) => {
    setManyTableData(NonOrderProductData);
    setUpdatedDetailGridData(NonOrderProductData);
  };

  const setUpdatedDetailsGridDataHandler = (rows) => {
    if (saveInFlightRef.current || isSubmitting) return;
    if (validateForm(formData)) {
      let fDtat = { ...formData, ManyJsonSave: rows };
      runStockTakeUpdate(fDtat);
    }

    setManyTableData(rows);

  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    let data = { ...formData };
    data[name] = value;
    setFormData(data);

    setErrorObject({ ...errorObject, [name]: null });
  };

  const handleReset = () => {
    setFormData({
      StockTakeDate: "",
      CompleteDate: "",
      StockTakeId: "",
      PreparedBy: "",
      ApprovedBy: "",
      ItemGroupId: "",
    });
  };

  const validateForm = (formData) => {
    let validateFields = ["StockTakeDate", "CompleteDate", "PreparedBy", "ApprovedBy"];
    let errorData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] = "field is Required !";
        isValid = false;
      }
    });
    setErrorObject(errorData);
    return isValid;
  };

  const handleUpdate = async (e) => {
    if (saveInFlightRef.current || isSubmitting) return;
    if (validateForm(formData)) {
      let FinalData = { ...formData, ManyJsonSave: ManyTableData };
      runStockTakeUpdate(FinalData);
    }
  };

  const handlePost = async (e) => {
    if (saveInFlightRef.current || isSubmitting) return;
    if (validateForm(formData)) {
      // let FinalData={...formData,'ManyJsonSave':ManyTableData,"IsCompleted":1};
      // mutateUpdate(FinalData);

      // Start Post Alert

      swal({
        title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
        text: t(
          DispensingLanguage[lan][menukey][
            "Do you really want to post the stock?"
          ]
        ),
        icon: "warning",
        buttons: [
          t(DispensingLanguage[lan][menukey]["No"]),
          t(DispensingLanguage[lan][menukey]["Yes"]),
        ],
        dangerMode: true,
      }).then((willAction) => {
        if (willAction) {
          if (saveInFlightRef.current || isSubmitting) return;
          let FinalData = {
            ...formData,
            ManyJsonSave: ManyTableData,
            IsCompleted: 1,
          };
          runStockTakeUpdate(FinalData);
        } else {
          setIsCompleted(0);
          let route = `${StockTakeId}`;
          props.history.push(route);
        }
      });
      // End Post Alert
    }
  };

  /*
useEffect(() => {    
}, [ManyTableData]); 

*/

  return (
    <>
      <StockTakeFormData
        errorObject={errorObject}
        addProductForm={false}
        formData={formData}
        handleChange={handleChange}
        handleRDateChange={handleRDateChange}
        handleReset={handleReset}
        handleUpdate={handleUpdate}
        handleAdd={handleAdd}
        ManyTableData={updatedDetailGridData}
        handleDataTableChange={handleDataTableChange}
        IsCompleted={IsCompleted}
        setUpdatedDetailsGridDataHandler={setUpdatedDetailsGridDataHandler}
        handlePost={handlePost}
        bFirst={bFirst}
        isFirstPhysical={isFirstPhysical}
        {...props}
        isSubmitting={isSubmitting}
      />
    </>
  );
};

export default EditStockTake;
